import { apiUrl } from "../../../config";
import axios from "axios";

export const state = {
    ListeHistorique:[],
    // Vrai pendant le chargement de l'historique : l'ecran affiche des lignes
    // fantomes plutot qu'un « aucun email » trompeur le temps de l'appel.
    HistoriqueLoading: false,
    contentEmail : null
};

export const mutations = {
    // Remplacement en un coup : pousser ligne par ligne redeclenchait le rendu
    // de la liste a chaque element.
    SET_HISTORIQUE(state, newValue) {
        state.ListeHistorique = newValue || [];
    },
    RESET_HISTORIQUE(state) {
        state.ListeHistorique=[]
    },
    SET_HISTORIQUE_LOADING(state, newValue) {
        state.HistoriqueLoading = !!newValue;
    },
    SET_CONTENTEMAIL(state, newValue) {
      state.contentEmail = (newValue);
  },

  NOTHING() {},
};

export const getters = {

    ListeHistorique(state) {
        return state.ListeHistorique;
    },
    HistoriqueLoading(state) {
        return state.HistoriqueLoading;
    },
    contentEmail(state) {
      return state.contentEmail;
    },

};

export const actions = {
  // This is automatically run in `src/state/store.js` when the app
  // starts, along with any other actions named `init` in other modules.
  // eslint-disable-next-line no-unused-vars
  init({ state, dispatch }) {
    dispatch("validate");
  },
 

 
  // Historique d'emailing d'un dossier, du plus recent au plus ancien.
  // `type` ('client' | 'notification') et `search` sont filtres cote serveur :
  // le corps des emails est du HTML volumineux, on evite de tout rapatrier.
  getHistorique({ commit }, { id, type, search } = {}) {
    commit("SET_HISTORIQUE_LOADING", true);

    return new Promise((resolve, reject) => {
      axios
        .get(apiUrl + "api/historique/"+id, {
          params: {
            ...(type ? { type } : {}),
            ...(search ? { search } : {}),
          },
          headers: {
            "X-Requested-With": "XMLHttpRequest",
            "Content-Type": "application/json",
            Authorization: "Bearer " + localStorage.getItem("auth"),
          },
        })
        .then((response) => {
          commit("SET_HISTORIQUE", response.data.data || []);
          commit("SET_HISTORIQUE_LOADING", false);
          resolve(true);
        })
        .catch((e) => {
          console.log(e);
          commit("SET_HISTORIQUE_LOADING", false);
          reject(e);
          //Vue.$notify('error filled', 'Erreur', e, { duration: 3000, permanent: false });
        });
    });
  },
  
 
  send_email({ commit }, { id,data } = {}) {
    //delete data['email']
     
    return new Promise((resolve, reject) => {
      axios
        .post(apiUrl + "api/send-mail/"+id, data, {
          headers: {
            "X-Requested-With": "XMLHttpRequest",
            "Content-Type": "application/json",
            Authorization: "Bearer " + localStorage.getItem("auth"),
          },
        })
        .then((response) => {
       
          commit("NOTHING",response);
          // commit("SET_TOKEN_USER",response.data.data.token)
          resolve(true);
        })
        .catch((e) => {
          console.log(e);
          reject(e);
          //Vue.$notify('error filled', 'Erreur', e, { duration: 3000, permanent: false });
        });
    });
  },


  send_notif({ commit }, { data, dossier, fichiers } = {}) {
    // Multipart plutot que JSON : les pieces jointes ne se serialisent pas en
    // JSON. `data` part donc en chaine, que le controleur decode.
    const formulaire = new FormData();
    formulaire.append("data", JSON.stringify(data));
    formulaire.append("dossier", dossier);
    (fichiers || []).forEach((fichier) => formulaire.append("fichiers[]", fichier));

    return new Promise((resolve, reject) => {
      axios
        .post(apiUrl + "api/send-notif", formulaire, {
          headers: {
            "X-Requested-With": "XMLHttpRequest",
            // Pas de Content-Type explicite : axios doit poser lui-meme la
            // frontiere multipart, sinon le serveur ne sait pas decouper.
            Authorization: "Bearer " + localStorage.getItem("auth"),
          },
        })
        .then((response) => {
       
          commit("NOTHING",response);
          // commit("SET_TOKEN_USER",response.data.data.token)
          resolve(true);
        })
        .catch((e) => {
          console.log(e);
          reject(e);
          //Vue.$notify('error filled', 'Erreur', e, { duration: 3000, permanent: false });
        });
    });
  },

  getcontentemail({ commit },{id}) {
    //delete data['email']
  
    return new Promise((resolve, reject) => {
      axios
        .get(apiUrl + "api/get-content-email/"+id, {
          headers: {
            "X-Requested-With": "XMLHttpRequest",
            "Content-Type": "application/json",
            Authorization: "Bearer " + localStorage.getItem("auth"),
          },
        })
        .then((response) => {
          
          let data=response.data.data

          
            commit("SET_CONTENTEMAIL",data);
          resolve(true);
        })
        .catch((e) => {
          console.log(e);
          reject(e);
          //Vue.$notify('error filled', 'Erreur', e, { duration: 3000, permanent: false });
        });
    });
  },


 

  
};

// ===
// Private helpers
// ===

// function saveState(key, state) {
//     window.localStorage.setItem(key, JSON.stringify(state))
// }
